<div class="mt-4 pt-5 mx-5">

  <div *ngIf="formatResponse" class="mt-5 d-flex justify-content-between">
    <div>
      <h3 class="hello">
        {{ "Hello" | translate }} {{ user ? ", " + user.name : "" }}
      </h3>
      <p class="welcome">{{ "Welcome to your resume review." | translate }}</p>
      <div class="d-flex flex-wrap">
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/format.png" />
          <h3 class="title">{{ "Format" | translate }}</h3>
          <span class="presentage">{{ cvScores.format }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/resume sections.png" />
          <h3 class="title">{{ "Headline" | translate }}</h3>
          <span class="presentage">{{ cvScores.headline }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/style.png" />
          <h3 class="title">{{ "Summary" | translate }}</h3>
          <span class="presentage">{{ cvScores.summary }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/skills.png" />
          <h3 class="title">{{ "Experience" | translate }}</h3>
          <span class="presentage">{{ cvScores.experience }}%</span>
        </div>
        <div class="text-center mx-3">
          <img class="item-img" src=".././../../assets/icon/content.png" />
          <h3 class="title">{{ "Education" | translate }}</h3>
          <span class="presentage">{{ cvScores.education }}%</span>
        </div>
      </div>
    </div>
    <app-circle-progress [progressValue]="cvScores.total" />
  </div>

  <div *ngIf="formatResponse" class="accodion-container">
    <p-accordion [multiple]="true">

      <p-accordionTab [toggleable]="true" [class.rtl-accordion]="isArabic">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/format.png" />
          <span class="mx-2"> {{ "Format" | translate }} </span>
          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.format" />
          </div>
        </ng-template>
        <div class="check" *ngFor="let key of getKeys(formatResponse.format)">
          <img [src]="getCheckIcon(key)" />
          <div *ngIf="contentData">
            <h3>{{ contentData[key]?.title }}</h3>
            <span>{{ contentData[key]?.description }}</span>
          </div>
        </div>
      </p-accordionTab>

      <p-accordionTab [toggleable]="true" [class.rtl-accordion]="isArabic">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/resume sections.png" />
          <span class="mx-2"> {{ "Headline" | translate }} </span>
          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.headline" />
          </div>
        </ng-template>
        <div class="check" *ngFor="let key of getKeys(formatResponse.headline)">
          <img [src]="getCheckIcon(key)" />
          <div *ngIf="contentData">
            <h3>{{ contentData[key]?.title }}</h3>
            <span>{{ contentData[key]?.description }}</span>
          </div>
        </div>
      </p-accordionTab>

      <p-accordionTab [toggleable]="true" [class.rtl-accordion]="isArabic">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/style.png" />
          <span class="mx-2"> {{ "Summary" | translate }} </span>
          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.summary" />
          </div>
        </ng-template>
        <div class="check" *ngFor="let key of getKeys(formatResponse.summary)">
          <img [src]="getCheckIcon(key)" />
          <div *ngIf="contentData">
            <h3>{{ contentData[key]?.title }}</h3>
            <span>{{ contentData[key]?.description }}</span>
          </div>
        </div>
      </p-accordionTab>

      <p-accordionTab [toggleable]="true" [class.rtl-accordion]="isArabic">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/content.png" />
          <span class="mx-2"> {{ "Experience" | translate }} </span>
          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.experience" />
          </div>
        </ng-template>
        <div *ngFor="let experience of formatResponse.experience">
          <div *ngFor="let key of getKeys(experience)">
            <div class="check" *ngIf="key !== 'jobDuties'">
              <img [src]="getCheckIcon(key)" />
              <div *ngIf="contentData">
                <h3>{{ contentData[key]?.title }}</h3>
                <span>{{ contentData[key]?.description }}</span>
              </div>
            </div>
          </div>
          <div *ngFor="let duty of experience.jobDuties">
            <div class="check" *ngFor="let key of getKeys(duty)">
              <img [src]="getCheckIcon(key)" />
              <div *ngIf="contentData">
                <h3>{{ contentData[key]?.title }}</h3>
                <span>{{ contentData[key]?.description }}</span>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </p-accordionTab>

      <p-accordionTab [toggleable]="true" [class.rtl-accordion]="isArabic">
        <ng-template pTemplate="header">
          <img class="item-img" src=".././../../assets/icon/skills.png" />
          <span class="mx-2"> {{ "Education" | translate }} </span>
          <div class="circle-progress">
            <app-circle-progress [progressValue]="cvScores.education" />
          </div>
        </ng-template>
        <div *ngFor="let education of formatResponse.education">
          <div class="check" *ngFor="let key of getKeys(education)">
            <img [src]="getCheckIcon(key)" />
            <div *ngIf="contentData">
              <h3>{{ contentData[key]?.title }}</h3>
              <span>{{ contentData[key]?.description }}</span>
            </div>
          </div>
          <hr />
        </div>
      </p-accordionTab>

    </p-accordion>
  </div>

  <div *ngIf="formatResponse && jobRanking" class="cv-ranking-section">
    <h2 class="cv-ranking-title">{{ "CV ranking" | translate }}</h2>

    <div class="cv-ranking-top-cards">
      <div class="cv-ranking-card">
        <span class="card-label">{{ "Overall Overview Score" | translate }}</span>
        <span class="card-score">{{ jobRanking.overallScore }}<span class="card-score-max">/100</span></span>
      </div>
      <div class="cv-ranking-card">
        <span class="card-label">{{ "AI Recommendation" | translate }}</span>
        <span class="card-recommendation">{{ jobRanking.grade }}</span>
      </div>
    </div>

    <div class="cv-summary-box">
      <span class="summary-label">{{ "Summary" | translate }}</span>
      <p class="summary-text">{{ jobRanking.summary }}</p>
    </div>

    <div class="cv-skills-section">
      <div class="skills-header">
        <span class="skills-title">{{ "Skills" | translate }}</span>
        <span class="skills-total-score">{{ jobRanking.overallScore }}/100</span>
      </div>

      <!-- Matched -->
      <div class="skill-row" (click)="jobRanking.matchBreakdown.skills.matched?.length && toggleList('matched')"
        [class.clickable]="jobRanking.matchBreakdown.skills.matched?.length">
        <div class="skill-icon-label">
          <div class="skill-icon-wrapper color-orange">
            <img class="skill-icon" src="assets/img/material-symbols-light_folder-match-outline-rounded.svg" />
          </div>
          <span class="skill-name">{{ "Matched" | translate }}</span>
        </div>
        <div class="skill-row-end">
          <div class="skill-circular-badge color-orange">
            <svg viewBox="0 0 36 36">
              <circle class="circle-bg" cx="18" cy="18" r="15.9" />
              <circle class="circle-fill" cx="18" cy="18" r="15.9"
                [style.stroke-dasharray]="getCircleDash(jobRanking.matchBreakdown.skills.score)" />
            </svg>
            <span>{{ jobRanking.matchBreakdown.skills.score }}%</span>
          </div>
          <span class="skill-chevron" *ngIf="jobRanking.matchBreakdown.skills.matched?.length"
            [class.open]="openLists['matched']">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
          <span class="skill-chevron invisible" *ngIf="!jobRanking.matchBreakdown.skills.matched?.length"></span>
        </div>
      </div>
      <div class="skill-tags-container"
        *ngIf="openLists['matched'] && jobRanking.matchBreakdown.skills.matched?.length">
        <span class="skill-tag tag-matched" *ngFor="let item of jobRanking.matchBreakdown.skills.matched">{{ item
          }}</span>
      </div>

      <!-- Missing -->
      <div class="skill-row" (click)="jobRanking.matchBreakdown.skills.missing?.length && toggleList('missing')"
        [class.clickable]="jobRanking.matchBreakdown.skills.missing?.length">
        <div class="skill-icon-label">
          <div class="skill-icon-wrapper color-yellow">
            <img class="skill-icon" src="assets/img/carbon_error.svg" />
          </div>
          <span class="skill-name">{{ "Missing" | translate }}</span>
        </div>
        <div class="skill-row-end">
          <div class="skill-circular-badge color-yellow">
            <svg viewBox="0 0 36 36">
              <circle class="circle-bg" cx="18" cy="18" r="15.9" />
              <circle class="circle-fill" cx="18" cy="18" r="15.9"
                [style.stroke-dasharray]="getCircleDash(jobRanking.matchBreakdown.skills.score)" />
            </svg>
            <span>{{ jobRanking.matchBreakdown.skills.missing?.length ?? 0 }}</span>
          </div>
          <span class="skill-chevron" *ngIf="jobRanking.matchBreakdown.skills.missing?.length"
            [class.open]="openLists['missing']">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </span>
          <span class="skill-chevron invisible" *ngIf="!jobRanking.matchBreakdown.skills.missing?.length"></span>
        </div>
      </div>
      <div class="skill-tags-container"
        *ngIf="openLists['missing'] && jobRanking.matchBreakdown.skills.missing?.length">
        <span class="skill-tag tag-missing" *ngFor="let item of jobRanking.matchBreakdown.skills.missing">{{ item
          }}</span>
      </div>

      <!-- Experience -->
      <div class="skill-row">
        <div class="skill-icon-label">
          <div class="skill-icon-wrapper color-blue">
            <img class="skill-icon" src="assets/img/hugeicons_work.svg" />
          </div>
          <span class="skill-name">{{ "Experience" | translate }}</span>
        </div>
        <div class="skill-row-end">
          <div class="skill-circular-badge color-blue">
            <svg viewBox="0 0 36 36">
              <circle class="circle-bg" cx="18" cy="18" r="15.9" />
              <circle class="circle-fill" cx="18" cy="18" r="15.9"
                [style.stroke-dasharray]="getCircleDash(jobRanking.matchBreakdown.experience.score)" />
            </svg>
            <span>{{ jobRanking.matchBreakdown.experience.score }}%</span>
          </div>
          <span class="skill-chevron invisible"></span>
        </div>
      </div>

      <!-- Education -->
      <div class="skill-row">
        <div class="skill-icon-label">
          <div class="skill-icon-wrapper color-red">
            <img class="skill-icon" src="assets/img/fluent-mdl2_learning-tools.svg" />
          </div>
          <span class="skill-name">{{ "Education" | translate }}</span>
        </div>
        <div class="skill-row-end">
          <div class="skill-circular-badge color-red">
            <svg viewBox="0 0 36 36">
              <circle class="circle-bg" cx="18" cy="18" r="15.9" />
              <circle class="circle-fill" cx="18" cy="18" r="15.9"
                [style.stroke-dasharray]="getCircleDash(jobRanking.matchBreakdown.education.score)" />
            </svg>
            <span>{{ jobRanking.matchBreakdown.education.score }}%</span>
          </div>
          <span class="skill-chevron invisible"></span>
        </div>
      </div>

      <!-- Keywords Coverage -->
      <div class="skill-row">
        <div class="skill-icon-label">
          <div class="skill-icon-wrapper color-green">
            <img class="skill-icon" src="assets/img/f7_doc.svg" />
          </div>
          <span class="skill-name">{{ "Keywords Coverage" | translate }}</span>
        </div>
        <div class="skill-row-end">
          <div class="skill-circular-badge color-green">
            <svg viewBox="0 0 36 36">
              <circle class="circle-bg" cx="18" cy="18" r="15.9" />
              <circle class="circle-fill" cx="18" cy="18" r="15.9"
                [style.stroke-dasharray]="getCircleDash(jobRanking.matchBreakdown.keywordsCoverage.score)" />
            </svg>
            <span>{{ jobRanking.matchBreakdown.keywordsCoverage.score }}%</span>
          </div>
          <span class="skill-chevron invisible"></span>
        </div>
      </div>
    </div>

    <div class="ai-insights-section">
      <h3 class="ai-insights-title">{{ "AI Insights" | translate }}</h3>
      <div class="ai-insights-grid">
        <div class="ai-insights-col" *ngIf="jobRanking.strengths?.length">
          <p class="insights-category-label">{{ "Key Strengths:" | translate }}</p>
          <ul class="insights-list">
            <li *ngFor="let item of jobRanking.strengths">{{ item }}</li>
          </ul>
        </div>
        <div class="ai-insights-col" *ngIf="jobRanking.gaps?.length">
          <p class="insights-category-label">{{ "Gaps:" | translate }}</p>
          <ul class="insights-list">
            <li *ngFor="let item of jobRanking.gaps">{{ item }}</li>
          </ul>
        </div>
        <div class="ai-insights-col" *ngIf="jobRanking.recommendations?.length">
          <p class="insights-category-label">{{ "Recommendations:" | translate }}</p>
          <ul class="insights-list">
            <li *ngFor="let item of jobRanking.recommendations">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <app-resume-builder-section></app-resume-builder-section>
</div>
